import { useState } from "react";
import EditNewCreditzForm from "./form";
import Header from "./header";
import PropTypes from 'prop-types';

const EditNewCreditz = ({values = {}, setView, additionalRoles}) => {

  return (
    <>
      <Header onEdit={() => setView()} />
      <EditNewCreditzForm
        values={values}
        additionalRoles={additionalRoles}
      />
    </>
  );
};

EditNewCreditz.propTypes = {
  setView: PropTypes.func,
  values: PropTypes.object,
  additionalRoles: PropTypes.array
}

export default EditNewCreditz;
